<div class="error404-content">
  <h1 class="title">404</h1>
  <p class="subtitle">{{'general.texts.pageNotFound' | translate}}</p>
  <app-button>{{'general.actions.backToApp' | translate}}</app-button>
</div>
